const tab = $('.category-selector-tab');
const selectList = $('.category-selector-select');

const setActiveTab = (event) => {
    event.preventDefault();

    const clickedButton = event.target;

    $(clickedButton).addClass('active');
    $(clickedButton).parent().siblings().children().removeClass('active');

    const activeButtonID = $('.category-selector-tab.active').attr('data-target');
    setActiveContentTab(activeButtonID);
}

const setActiveSelectOption = () => {
    const selectedOptionValue = $('.category-selector-select option:selected').val();

    setActiveContentTab(selectedOptionValue);
}

const setActiveContentTab = (activeId) => {
    $('.accordion--faq__toggle').removeClass('accordion--faq__toggle--active');
    $('.accordion--faq__toggle').filter('div[data-toggle-id='+activeId+']').addClass('accordion--faq__toggle--active');
}

const setInitialContentTab = () => {
    const activeId = $('.category-selector-tab.active').attr('data-target');

    if ($('.category-selector-tab').length > 0) {
        $('.accordion--faq__toggle').filter('div[data-toggle-id='+activeId+']').addClass('accordion--faq__toggle--active');
    } else {
        $('.accordion--faq__toggle').addClass('accordion--faq__toggle--active');
    }
}

const events = () => {
    $(tab).on('click', setActiveTab);
    $(selectList).on('change', setActiveSelectOption);
}

const init = () => {
    events();
    setInitialContentTab();
}

export default init;